export default function WorkFromHomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="22"
      height="22"
      x="0"
      y="0"
      viewBox="0 0 24 24"
      // style="enable-background:new 0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M20 9.5 14 5a2.514 2.514 0 0 0-3 0L5 9.5a2.514 2.514 0 0 0-1 2V19a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-7.5a2.514 2.514 0 0 0-1-2zM8.89 20l-.749-3h4.774a.25.25 0 0 1 .242.189L13.86 20zM16 20h-1.11l-.763-3.054A1.247 1.247 0 0 0 12.915 16H11.5a2.5 2.5 0 0 1 4.5 1.5zm-4-7.5a1.5 1.5 0 1 1 1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm8 6.5a1 1 0 0 1-1 1h-2v-2.5a3.49 3.49 0 0 0-1.9-3.1 2.5 2.5 0 1 0-3.21 0 3.5 3.5 0 0 0-1.543 1.6H8.141a1 1 0 0 0-.971 1.242L7.86 20H6a1 1 0 0 1-1-1v-7.5a1.506 1.506 0 0 1 .6-1.2l6-4.5a1.508 1.508 0 0 1 1.8 0l6 4.5a1.506 1.506 0 0 1 .6 1.2z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
      </g>
    </svg>
  );
}
